const calculateInterventionEventRateFromControlEventRateAndStatistic = (controlEventRate, statistic) => {
    let riskDifference = NaN;
    let interventionEventRate = NaN;
    if (statistic) {
        let riskDifferenceStatistic;
        let riskRatioStatistic;
        let oddsRatioStatistic;
        for (const stat of statistic) {
            if (stat.statisticType && stat.statisticType.coding && stat.statisticType.coding.length > 0 &&
                codeMatchesRiskDifference(stat.statisticType.coding[0].code)) {
                if (stat.quantity && stat.quantity.value !== undefined && !isNaN(stat.quantity.value)) {
                    riskDifferenceStatistic = stat;
                }
            }
            if (stat.statisticType && stat.statisticType.coding && stat.statisticType.coding.length > 0 &&
                (codeMatchesRelativeRisk(stat.statisticType.coding[0].code) || //risk ratio
                    stat.statisticType.coding[0].code === 'STATO:0000677' || stat.statisticType.coding[0].code === 'TBD:0000026' || //hazard ratio currently treated like risk ratio
                    stat.statisticType.coding[0].code === 'STATO:0000678' || stat.statisticType.coding[0].code === 'TBD:0000028' || //prevalence ratio currently treated like risk ratio
                    stat.statisticType.coding[0].code === 'STATO:0000680' || stat.statisticType.coding[0].code === 'TBD:0000027' //incidence rate ratio currently treated like risk ratio
                )) {
                if (stat.quantity && stat.quantity.value !== undefined && !isNaN(stat.quantity.value)) {
                    riskRatioStatistic = stat;
                }
            }
            if (stat.statisticType && stat.statisticType.coding && stat.statisticType.coding.length > 0 &&
                (stat.statisticType.coding[0].code === 'STATO:0000182' || stat.statisticType.coding[0].code === 'C16932')) {
                if (stat.quantity && stat.quantity.value !== undefined && !isNaN(stat.quantity.value)) {
                    oddsRatioStatistic = stat;
                }
            }
        }
        if (oddsRatioStatistic) {
            let oddsRatio = oddsRatioStatistic.quantity.value;
            let controlOdds = controlEventRate / (100 - controlEventRate);
            let interventionOdds = controlOdds * oddsRatio;
            interventionEventRate = (interventionOdds / (interventionOdds + 1)) * 100;
            riskDifference = interventionEventRate - controlEventRate;
        } else if (riskRatioStatistic) {
            let relativeRisk = riskRatioStatistic.quantity.value;
            interventionEventRate = controlEventRate * relativeRisk;
            riskDifference = interventionEventRate - controlEventRate;
        } else if (riskDifferenceStatistic) {
            riskDifference = riskDifferenceStatistic.quantity.value * 100;
            interventionEventRate = controlEventRate + riskDifference;
        }
        if (isNaN(riskDifference)) {
            if (!isNaN(controlEventRate)) {
                for (const stat of statistic) {
                    if (stat.statisticType && stat.statisticType.coding && stat.statisticType.coding.length > 0 && stat.statisticType.coding[0].code) {
                        const statCode = stat.statisticType.coding[0].code;
                        if (checkIfStatisticAbsoluteOrRelative(statCode) === "absolute") {
                            if (stat.quantity && stat.quantity.value !== undefined && !isNaN(stat.quantity.value)) {
                                let absoluteDifference = stat.quantity.value * 100;
                                interventionEventRate = controlEventRate + absoluteDifference;
                                riskDifference = absoluteDifference;
                            }
                        } else if (checkIfStatisticAbsoluteOrRelative(statCode) === "relative") {
                            if (stat.quantity && stat.quantity.value !== undefined && !isNaN(stat.quantity.value)) {
                                let relativeDifference = stat.quantity.value;
                                interventionEventRate = controlEventRate * relativeDifference;
                                riskDifference = interventionEventRate - controlEventRate;
                            }
                        }
                    }
                }
            }
        }
    }
    return interventionEventRate;
};

const checkIfStatisticAbsoluteOrRelative = (statisticCode) => {
    const absoluteList = ["C44256", "STATO:0000607", "STATO:0000424", "0000424", "C16726", "C17010", "C53319", "0000100", "0000457", "C28007", "C25463", "C25564", "C25570", "absolute-MedianDiff", "predictedRisk"];
    const relativeList = ['C93150', 'STATO:0000245', 'STATO:0000182', 'STATO:0000677', 'STATO:0000678', 'STATO:0000680', "C93152", "C93150", "C16932", "rate-ratio", 'STATO:0000245', 'STATO:0000182', 'TBD:0000026', 'TBD:0000028', 'TBD:0000027'];
    if (absoluteList.includes(statisticCode)) {
        return "absolute";
    } else if (relativeList.includes(statisticCode)) {
        return "relative";
    } else {
        return "Not recognized";
    }
};

const codeMatchesPercentage = (code) => {
    return (code === 'STATO:0000639' || code === 'TBD:0000017');
};

const codeMatchesProportion = (code) => {
    return (code === "STATO:0000607" || code === "C44256" || code === "TBD:0000185" || code === 'TBD:0000018' || code === 'STATO:0000620');
};

const codeMatchesRelativeRisk = (code) => {
    return (code === 'STATO:0000245' || code === 'C93152' || code === 'C93150');
};

const codeMatchesRiskDifference = (code) => {
    return (code === 'STATO:0000424' || code === "0000424");
};

const extractControlEventRateFromStatistic = (statistic) => {
    let controlEventRate = NaN;
    for (const stat of statistic) {
        if (stat.statisticType && stat.statisticType.coding && stat.statisticType.coding.length > 0 &&
            codeMatchesProportion(stat.statisticType.coding[0].code)) {
            if (stat.quantity && stat.quantity.value !== undefined && !isNaN(stat.quantity.value)) {
                controlEventRate = stat.quantity.value * 100;
                break;
            }
        }
        if (stat.statisticType && stat.statisticType.coding && stat.statisticType.coding.length > 0 &&
            codeMatchesPercentage(stat.statisticType.coding[0].code)) {
            if (stat.quantity && stat.quantity.value !== undefined && !isNaN(stat.quantity.value)) {
                controlEventRate = stat.quantity.value;
                break;
            }
        }
        if (stat.statisticType && stat.statisticType.coding && stat.statisticType.coding.length > 0 &&
            (stat.statisticType.coding[0].code === 'STATO:0000047')) {
            if (stat.quantity && stat.quantity.value !== undefined && !isNaN(stat.quantity.value) && stat.sampleSize) {
                let denominator = stat.sampleSize.numberAnalyzed || stat.sampleSize.knownDataCount || stat.sampleSize.numberOfParticipants || 0;
                if (denominator > 0) {
                    controlEventRate = (stat.quantity.value / denominator) * 100;
                    break;
                }
            }
        }
    }
    return controlEventRate;
};

const generateSectionTextForAssertion = (section, comparativeEvidenceJson, sourceReferences) => {
    if (comparativeEvidenceJson) {
        section.entry = [sourceReferences.comparativeEvidence];
        if (comparativeEvidenceJson.assertion) {
            section.text = {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + comparativeEvidenceJson.assertion + "</p></div>"
            };
        } else {
            section.text = {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No assertion provided.]</p></div>"
            }
        }
    }
};

const generateSectionTextFromCalculatedInterventionResult = (section, interventionResult) => {
    if (isNaN(interventionResult)) {
        section.text = {
            "status": "generated",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[Not a proportion.]</p></div>"
        };
    } else {
        section.text = {
            "status": "generated",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + parseFloat(interventionResult.toFixed(2)) + "%</p></div>"
        };
    }
};

const generateSectionTextForCalculatedInterventionResult = (section, comparativeEvidenceJson,
    comparatorOnlyEvidenceJson, sourceReferences) => {
    if (comparativeEvidenceJson && comparatorOnlyEvidenceJson) {
        section.entry = [sourceReferences.comparatorOnlyEvidence, sourceReferences.comparativeEvidence];
        let controlEventRate = NaN;
        let interventionResult = NaN;
        if (comparatorOnlyEvidenceJson.statistic) {
            controlEventRate = extractControlEventRateFromStatistic(comparatorOnlyEvidenceJson.statistic);
        }
        if (comparativeEvidenceJson.statistic) {
            interventionResult = calculateInterventionEventRateFromControlEventRateAndStatistic(controlEventRate, comparativeEvidenceJson.statistic);
        }
        generateSectionTextFromCalculatedInterventionResult(section, interventionResult);
    }
};

const generateSectionTextForCertaintyOfEvidence = (section, comparativeEvidenceJson, sourceReferences) => {
    if (comparativeEvidenceJson) {
        section.entry = [sourceReferences.comparativeEvidence];
        if (comparativeEvidenceJson.certainty?.length > 0) {
            section.text = {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No Overall certainty rating found.]</p></div>"
            };
            for (const certainty of comparativeEvidenceJson.certainty) {
                if (certainty.type?.coding?.[0]?.code === "Overall") {
                    if (certainty.rating && certainty.rating.coding && certainty.rating.coding.length > 0 && certainty.rating.coding[0].display) {
                        section.text = {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + certainty.rating.coding[0].display + "</p></div>"
                        };
                    }
                }
            }
        } else {
            section.text = {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No certainty rating found.]</p></div>"
            }
        }
    }
};

const generateSectionTextForEffectEstimate = (section, comparativeEvidenceJson, sourceReferences) => {
    if (comparativeEvidenceJson) {
        section.entry = [sourceReferences.comparativeEvidence];
        if (comparativeEvidenceJson.statistic?.length > 0) {
            let statisticNarrativeSummary = "";
            for (const statistic of comparativeEvidenceJson.statistic) {
                let statisticTypeDisplay = '';
                let statisticValueString = '';
                let statisticValueNumber;
                let attributeEstimateDisplay = '';
                let lowValue = 'NA';
                let highValue = 'NA';
                let lowValueNumber;
                let highValueNumber;
                let isARiskDifference = false;
                if (statistic.statisticType && statistic.statisticType.coding && statistic.statisticType.coding.length > 0 && statistic.statisticType.coding[0].display) {
                    statisticTypeDisplay = statistic.statisticType.coding[0].display + ' ';
                    if (codeMatchesRiskDifference(statistic.statisticType.coding[0].code)) {
                        isARiskDifference = true;
                    }
                }
                if (statistic.quantity && statistic.quantity.value !== undefined && statistic.quantity.value !== null && !isNaN(statistic.quantity.value)) {
                    statisticValueNumber = Number(statistic.quantity.value);
                    if (statistic.quantity.unit !== undefined && statistic.quantity.unit !== "") {
                        statisticValueString = parseFloat(statisticValueNumber.toFixed(2)) + " " + statistic.quantity.unit;
                    } else if (isARiskDifference) {
                        statisticValueString = parseFloat((statisticValueNumber * 100).toFixed(2)) + "%";
                    } else {
                        statisticValueString = parseFloat(statisticValueNumber.toFixed(2)).toString();
                    }
                }
                if (statistic.attributeEstimate && statistic.attributeEstimate.length > 0) {
                    const attributeEstimate = statistic.attributeEstimate[0];
                    let attributeEstimateType = '';
                    if (attributeEstimate.type && attributeEstimate.type.coding && attributeEstimate.type.coding.length > 0 && attributeEstimate.type.coding[0].display) {
                        attributeEstimateType = '95% ' + attributeEstimate.type.coding[0].display;
                    }
                    if (attributeEstimate.range) {
                        if (attributeEstimate.range.low && attributeEstimate.range.low.value !== undefined && !isNaN(attributeEstimate.range.low.value)) {
                            lowValueNumber = Number(attributeEstimate.range.low.value);
                            if (attributeEstimate.range.low.unit !== undefined && attributeEstimate.range.low.unit !== "") {
                                lowValue = parseFloat(lowValueNumber.toFixed(2)) + " " + attributeEstimate.range.low.unit;
                            } else if (isARiskDifference) {
                                lowValue = parseFloat((lowValueNumber * 100).toFixed(2)) + "%";
                            } else {
                                lowValue = parseFloat(lowValueNumber.toFixed(2)).toString();
                            }
                        }
                        if (attributeEstimate.range.high && attributeEstimate.range.high.value !== undefined && !isNaN(attributeEstimate.range.high.value)) {
                            highValueNumber = Number(attributeEstimate.range.high.value);
                            if (attributeEstimate.range.high.unit !== undefined && attributeEstimate.range.high.unit !== "") {
                                highValue = parseFloat(highValueNumber.toFixed(2)) + " " + attributeEstimate.range.high.unit;
                            } else if (isARiskDifference) {
                                highValue = parseFloat((highValueNumber * 100).toFixed(2)) + "%";
                            } else {
                                highValue = parseFloat(highValueNumber.toFixed(2)).toString();
                            }
                        }
                    }
                    attributeEstimateDisplay = ' (' + attributeEstimateType + ' ' + lowValue + ' to ' + highValue + ')'
                }
                if (statisticNarrativeSummary) {
                    statisticNarrativeSummary += "; " + statisticTypeDisplay + statisticValueString + attributeEstimateDisplay
                } else {
                    statisticNarrativeSummary = statisticTypeDisplay + statisticValueString + attributeEstimateDisplay
                }
            }
            section.text = {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + statisticNarrativeSummary + "</p></div>"
            };
        } else {
            section.text = {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No statistic found.]</p></div>"
            }
        }
    }
};

const generateSectionTextForPercentage = (section, statistic) => {
    if (statistic?.length > 0) {
        let percentage = NaN;
        for (const stat of statistic) {
            if (stat.statisticType && stat.statisticType.coding && stat.statisticType.coding.length > 0 &&
                codeMatchesProportion(stat.statisticType.coding[0].code)) {
                if (stat.quantity && stat.quantity.value !== undefined && !isNaN(stat.quantity.value)) {
                    percentage = stat.quantity.value * 100;
                    break;
                }
            }
            if (stat.statisticType && stat.statisticType.coding && stat.statisticType.coding.length > 0 &&
                codeMatchesPercentage(stat.statisticType.coding[0].code)) {
                if (stat.quantity && stat.quantity.value !== undefined && !isNaN(stat.quantity.value)) {
                    percentage = stat.quantity.value;
                    break;
                }
            }
            if (stat.statisticType && stat.statisticType.coding && stat.statisticType.coding.length > 0 &&
                (stat.statisticType.coding[0].code === 'STATO:0000047')) {
                if (stat.quantity && stat.quantity.value !== undefined && !isNaN(stat.quantity.value) && stat.sampleSize) {
                    let denominator = stat.sampleSize.numberAnalyzed || stat.sampleSize.knownDataCount || stat.sampleSize.numberOfParticipants || 0;
                    if (denominator > 0) {
                        percentage = (stat.quantity.value / denominator) * 100;
                        break;
                    }
                }
            }
        }
        if (isNaN(percentage)) {
            section.text = {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[Not a proportion.]</p></div>"
            }
        } else {
            section.text = {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + parseFloat(percentage.toFixed(2)) + "%</p></div>"
            }
        }
    } else {
        section.text = {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No statistic found.]</p></div>"
        }
    }
};

const generateSectionTextForRelativeImportance = (section, outcomeImportanceJson, sourceReferences) => {
    if (outcomeImportanceJson) {
        section.entry = [sourceReferences.outcomeImportance];
        section.text = {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No relative outcome importance rating found.]</p></div>"
        }
        if (outcomeImportanceJson.content?.length > 0) {
            let sectionTextDiv = "";
            let sectionTextDivDesirability = "";
            let sectionTextDivRelativeImportance = "";
            for (const content of outcomeImportanceJson.content) {
                if (content.type && content.type.coding && content.type.coding.length > 0 && content.type.coding[0].code) {
                    if (content.type.coding[0].code === "desirability") {
                        if (content.classifier?.length > 0 && content.classifier[0].coding?.length > 0 &&
                            content.classifier[0].coding[0]) {
                            sectionTextDivDesirability = content.classifier[0].coding[0].display || content.classifier[0].coding[0].code;
                        }
                    }
                    if (content.type.coding[0].code === "relative-importance") {
                        if (content.quantity?.value >= 0) { //whether .value is a string or integer or float this is a safe comparison, if content.quantity.value is null (not undefined) then this statement is also true
                            sectionTextDivRelativeImportance = content.quantity.value.toString() + "%"; //This will crash if .value is null
                        }
                    }
                }
            }
            if (sectionTextDivRelativeImportance) {
                sectionTextDiv = sectionTextDivDesirability + " " + sectionTextDivRelativeImportance;
            }
            if (sectionTextDiv) {
                section.text = {
                    "status": "generated",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + sectionTextDiv + "</p></div>"
                };
            }
        }
    }
};

const generateSectionTextForSampleSize = (section, comparativeEvidenceJson, sourceReferences) => {
    if (comparativeEvidenceJson) {
        section.entry = [sourceReferences.comparativeEvidence];
        section.text = {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No statistic found.]</p></div>"
        }
        if (comparativeEvidenceJson.statistic?.length > 0) {
            for (const statistic of comparativeEvidenceJson.statistic) {
                let resultDisplayList = [];
                if (statistic.sampleSize) {
                    if (statistic.sampleSize.numberOfStudies !== undefined && statistic.sampleSize.numberOfStudies !== "") {
                        resultDisplayList.push(statistic.sampleSize.numberOfStudies + ' studies');
                    }
                    if (statistic.sampleSize.numberOfParticipants !== undefined && statistic.sampleSize.numberOfParticipants !== "") {
                        resultDisplayList.push(statistic.sampleSize.numberOfParticipants + ' participants');
                    }
                    if (statistic.sampleSize.numberAnalyzed !== undefined && statistic.sampleSize.numberAnalyzed !== "") {
                        resultDisplayList.push(statistic.sampleSize.numberAnalyzed + ' analyzed');
                    }
                    if (statistic.sampleSize.knownDataCount !== undefined && statistic.sampleSize.knownDataCount !== "") {
                        resultDisplayList.push(statistic.sampleSize.knownDataCount + ' without missing data');
                    }
                }
                if ((statistic.numberAffected !== undefined && statistic.numberAffected !== "") || (statistic.numberOfEvents !== undefined && statistic.numberOfEvents !== "")) {
                    let abc = statistic.numberAffected !== undefined ? statistic.numberAffected : statistic.numberOfEvents;
                    resultDisplayList.push(abc + ' events');
                }
                if (resultDisplayList.length) {
                    section.text = {
                        "status": "generated",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + resultDisplayList.join(', ') + "</p></div>"
                    };
                    break;
                } else {
                    section.text = {
                        "status": "empty",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No sample size data.]</p></div>"
                    };
                }
            }
        }
    }
};

export {
    calculateInterventionEventRateFromControlEventRateAndStatistic,
    checkIfStatisticAbsoluteOrRelative, codeMatchesPercentage, codeMatchesProportion,
    codeMatchesRelativeRisk, codeMatchesRiskDifference, extractControlEventRateFromStatistic,
    generateSectionTextForAssertion,
    generateSectionTextFromCalculatedInterventionResult,
    generateSectionTextForCalculatedInterventionResult,
    generateSectionTextForCertaintyOfEvidence,
    generateSectionTextForEffectEstimate,
    generateSectionTextForPercentage,
    generateSectionTextForRelativeImportance,
    generateSectionTextForSampleSize
};